import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { formatStopTime } from '@/utils/timeStrings'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsItineraryItemDropoffTime',
  props: {
    dropoffDatetime: null,
    timeZone: null
  },
  setup(__props: any) {

const props = __props as {
  dropoffDatetime: string
  timeZone: string
};



const stopTime = computed(() => {
  return formatStopTime(props.dropoffDatetime, props.timeZone)
})

return { __sfc: true,props, stopTime }
}

})